<template>
  <div class="service-slider">
    <div class="swiper-button-next slider-btn" v-if="showNavSwiper"></div>
    <div class="swiper-button-prev slider-btn" v-if="showNavSwiper"></div>
    <swiper ref="awesomeSwiperServices" :options="swiperOptionServices">
      <swiper-slide
        class="service-slider__item"
        v-for="(category, index) in allCat"
        :key="index"
      >
        <a
          class="service-slider__item__wrap"
          :class="sliderKeyword === category.CategoryName ? 'selected' : ''"
          href="javascript:void(0)"
          @click="saveSelected(category.CategoryName), filerSlider()"
        >
          <div class="service-slider__item__wrap__img ">
            <img :src="urlAPI + category.Icon" :alt="category.CategoryName" />
          </div>
          <div class="service-slider__item__description">
            {{ category.CategoryName }}
          </div>
        </a>
      </swiper-slide>
      <!-- <swiper-slide class="service-slider__item">
        <img src="../../../Assets/Images/smile.svg" alt="service name" />
        <div class="service-slider__item__description">
          خدمات الافراد
        </div>
      </swiper-slide>
      <swiper-slide class="service-slider__item">
        <img src="../../../Assets/Images/smile.svg" alt="service name" />
        <div class="service-slider__item__description">
          خدمات الافراد
        </div>
      </swiper-slide> -->
      <!-- <swiper-slide class="service-slider__item">
        <img src="../../../Assets/Images/smile.svg" alt="service name" />
        <div class="service-slider__item__description">
          خدمات الافراد
        </div>
      </swiper-slide>
      <swiper-slide class="service-slider__item">
        <img src="../../../Assets/Images/smile.svg" alt="service name" />
        <div class="service-slider__item__description">
          خدمات الافراد
        </div>
      </swiper-slide>
      <swiper-slide class="service-slider__item">
        <img src="../../../Assets/Images/smile.svg" alt="service name" />
        <div class="service-slider__item__description">
          خدمات الافراد
        </div>
      </swiper-slide>
      <swiper-slide class="service-slider__item">
        <img src="../../../Assets/Images/smile.svg" alt="service name" />
        <div class="service-slider__item__description">
          خدمات الافراد
        </div>
      </swiper-slide>
      <swiper-slide class="service-slider__item">
        <img src="../../../Assets/Images/smile.svg" alt="service name" />
        <div class="service-slider__item__description">
          خدمات الافراد
        </div>
      </swiper-slide>
      <swiper-slide class="service-slider__item">
        <img src="../../../Assets/Images/smile.svg" alt="service name" />
        <div class="service-slider__item__description">
          خدمات الافراد
        </div>
      </swiper-slide> -->
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";

let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      info: null,
      sliderKeyword: "",
      urlAPI: apiUrl,
      showNavSwiper: true,
      swiperOptionServices: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: false,
        slidesPerView: 6,
        spaceBetween: 40,
        allowTouchMove: true,
        centeredSlides: false,
        slideToClickedSlide: true,
        onClick: function(e) {
          e.preventDefault();
          alert("clickSlide");
        },
        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
            allowTouchMove: true,
          },
          500: {
            slidesPerView: 3,
            spaceBetween: 30,
            allowTouchMove: true,
          },
        },
      },
    };
  },
  methods: {
    saveSelected(sliderKeyword) {
      this.sliderKeyword = sliderKeyword;
      this.$emit("sliderKeyword", this.sliderKeyword);
    },
  },
  props: ["allCat", "filerSlider", "tarckApplyFilter"],
  computed: {
    swiper() {
      return this.$refs.awesomeSwiperServices.$swiper;
    },
  },
  watch: {
    tarckApplyFilter() {
      this.sliderKeyword = this.allCat[0].CategoryName;
    },
  },
  mounted() {
    if (window.innerWidth < 768) {
      if (this.allCat.length > 4) {
        this.showNavSwiper = true;
      } else {
        this.showNavSwiper = false;
      }
    } else {
      if (this.allCat.length > 5) {
        this.showNavSwiper = true;
      } else {
        this.showNavSwiper = false;
      }
    }
  },
};
</script>
